export default __webpack_public_path__ + "static/media/Group1200.ff67a7f9.svg";